// extracted by mini-css-extract-plugin
export default {"commentsBtn":"commentsBtn_commentsBtn__pTdy6","commentsNumber":"commentsBtn_commentsNumber__7ZJLF"};